/**
 * BC Atacado — comportamento dos blocos de atacado (grade, barra de progresso, guarda do checkout).
 *
 * Carregado por snippets/bc-atacado-head.liquid com `defer`. JS puro, sem jQuery.
 * Não altera theme.min.js: conversa com o tema pelos eventos que ele já expõe
 * (`cart:updated`, `cart:refresh`) e pela Section Rendering API.
 *
 * Configuração: window.BCAtacadoConfig (impressa em Liquid a partir das configurações do tema).
 */
(function () {
  'use strict';

  if (window.BCAtacado) return; // evita carregar duas vezes

  var CFG = window.BCAtacadoConfig || {};
  var FAIXAS = (CFG.faixas || []).slice().sort(function (a, b) { return a.qtd - b.qtd; });
  var RAIZ = (CFG.urlRaiz || '/').replace(/\/$/, '');
  var URL_CARRINHO = CFG.urlCarrinho || RAIZ + '/cart';
  // rodada 2: um termo só em todo o pedido, «peças» (as faixas, a grade e a nota dos kits já falam em peças)
  var PECA = 'peça';
  var PECAS = 'peças';

  var ultimoCarrinho = null;

  /* ---------- utilidades ---------- */

  // espaço não separável entre «R$» e o valor: nenhuma tela quebra «R$ / 199,50» (rodada 1)
  var NBSP = String.fromCharCode(160);

  function dinheiro(centavos) {
    var negativo = centavos < 0;
    var partes = (Math.abs(centavos) / 100).toFixed(2).split('.');
    var inteiro = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return (negativo ? '-' : '') + 'R$' + NBSP + inteiro + ',' + partes[1];
  }

  function plural(n, um, varios) {
    return n + ' ' + (n === 1 ? um : varios);
  }

  /** «12 camisetas + 1 kit»: as peças do progressivo, os kits e os demais itens, cada um com seu nome (rodada 1 item 2). */
  function resumoItens(pecas, kits, outros) {
    var partes = [];
    if (pecas > 0) partes.push(plural(pecas, PECA, PECAS));
    if (kits > 0) partes.push(plural(kits, 'kit', 'kits'));
    if (outros > 0) partes.push(plural(outros, 'outro item', 'outros itens'));
    return partes.join(' + ');
  }

  /** Troca o texto de um elemento e, se mudou, dá um pulso curto (classe bc-pulso, só visual). */
  function trocarTexto(el, texto) {
    if (!el || el.textContent === texto) return;
    el.textContent = texto;
    el.classList.remove('bc-pulso');
    void el.offsetWidth; // reinicia a animação
    el.classList.add('bc-pulso');
  }

  /** Preço por peça para uma quantidade de peças elegíveis. */
  function precoPorPeca(pecas) {
    var preco = CFG.precoBase || 0;
    FAIXAS.forEach(function (f) { if (pecas >= f.qtd) preco = f.preco; });
    return preco;
  }

  /** Próxima faixa ainda não atingida, ou null. */
  function proximaFaixa(pecas) {
    for (var i = 0; i < FAIXAS.length; i++) {
      if (pecas < FAIXAS[i].qtd) return FAIXAS[i];
    }
    return null;
  }

  function buscarCarrinho() {
    return fetch(RAIZ + '/cart.js', { cache: 'no-store', credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('cart.js ' + r.status);
        return r.json();
      })
      .then(function (carrinho) {
        ultimoCarrinho = carrinho;
        return carrinho;
      });
  }

  function aviso(texto, link) {
    var el = document.querySelector('.bc-aviso');
    if (!el) {
      el = document.createElement('div');
      el.className = 'bc-aviso';
      el.setAttribute('role', 'alert');
      document.body.appendChild(el);
    }
    el.textContent = texto;
    if (link) {
      var a = document.createElement('a');
      a.href = link.href;
      a.textContent = link.texto;
      el.appendChild(document.createTextNode(' '));
      el.appendChild(a);
    }
    el.classList.add('bc-aviso--visivel');
    clearTimeout(aviso._t);
    aviso._t = setTimeout(function () { el.classList.remove('bc-aviso--visivel'); }, 6000);
  }

  /* ---------- barra de progresso ---------- */

  /**
   * Busca a barra renderizada pelo servidor (sections/bc-progresso.liquid) e troca o conteúdo
   * de todas as barras da página. Só busca se o carrinho mudou em relação ao que está na tela.
   */
  function atualizarBarras(carrinho) {
    var barras = document.querySelectorAll('[data-bc-progresso]');
    if (!barras.length) return Promise.resolve();

    if (carrinho) {
      var iguais = Array.prototype.every.call(barras, function (b) {
        return b.getAttribute('data-itens') === String(carrinho.item_count) &&
               b.getAttribute('data-total') === String(carrinho.total_price);
      });
      if (iguais) return Promise.resolve();
    }

    return fetch(RAIZ + '/?sections=bc-progresso', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (json) {
        if (!json || !json['bc-progresso']) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = json['bc-progresso'];
        var nova = tmp.querySelector('[data-bc-progresso]');
        if (!nova) return;
        // Busca de novo: o mini-cart pode ter sido re-renderizado pelo tema enquanto a resposta chegava.
        document.querySelectorAll('[data-bc-progresso]').forEach(function (b) {
          // guarda a largura das trilhas para a troca animar do valor antigo até o novo
          var antes = Array.prototype.map.call(b.querySelectorAll('.bc-prog__barra'), function (el) { el._bcTexto = null; return el.style.width; });
          b.innerHTML = nova.innerHTML;
          Array.prototype.forEach.call(b.querySelectorAll('.bc-prog__barra'), function (el, i) {
            var alvo = el.style.width;
            if (!antes[i] || antes[i] === alvo) return;
            el.style.animation = 'none';
            el.style.width = antes[i];
            void el.offsetWidth;
            el.style.width = alvo;
          });
          ['data-itens', 'data-total', 'data-pecas', 'data-kits', 'data-outros', 'data-desconto'].forEach(function (attr) {
            if (nova.hasAttribute(attr)) b.setAttribute(attr, nova.getAttribute(attr));
          });
          ['bc-prog--min-ok', 'bc-prog--faixa-ok'].forEach(function (cl) { b.classList.toggle(cl, nova.classList.contains(cl)); });
          // no produto quem decide se o cartão aparece é a grade (sacola + seleção); nos demais, sempre aparece
          if (!b.classList.contains('bc-prog--produto')) b.hidden = false;
          Array.prototype.forEach.call(b.querySelectorAll('[data-bc-conta], [data-bc-frase], [data-bc-rot-faixa], [data-bc-cap-min], [data-bc-rot-min], [data-bc-eco]'), function (el) { el._bcTexto = null; });
        });
        document.querySelectorAll('bc-grade').forEach(function (g) { if (g.atualizar) g.atualizar(); });
      })
      .catch(function () { /* a barra fica como está; não bloqueia a compra */ });
  }

  function aoMudarCarrinho(evento) {
    var carrinho = evento && evento.detail && evento.detail.cart;
    if (carrinho) ultimoCarrinho = carrinho;
    clearTimeout(aoMudarCarrinho._t);
    aoMudarCarrinho._t = setTimeout(function () { atualizarBarras(carrinho); }, 150);
  }

  document.documentElement.addEventListener('cart:updated', aoMudarCarrinho);
  document.documentElement.addEventListener('cart:refresh', aoMudarCarrinho);

  /* ---------- preço, faixas e cartão "Seu pedido" na página de produto ---------- */

  /** Faixa em que o lojista está: -1 sem peças, 0 preço base, 1 faixa 1, 2 faixa 2. */
  function faixaAtual(pecas) {
    var i = pecas > 0 ? 0 : -1;
    FAIXAS.forEach(function (f, k) { if (pecas >= f.qtd) i = k + 1; });
    return i;
  }

  /** O que já está na sacola, lido do cartão renderizado pelo servidor. */
  function lerSacola() {
    var b = document.querySelector('[data-bc-progresso]');
    function n(a) { return b ? parseInt(b.getAttribute(a), 10) || 0 : 0; }
    var s = { pecas: n('data-pecas'), total: n('data-total'), desconto: n('data-desconto'), itens: n('data-itens'), kits: n('data-kits'), outros: n('data-outros') };
    // cartão antigo, sem data-kits/data-outros: o que não conta para o progressivo vira «outros itens»
    if (b && !b.hasAttribute('data-outros')) s.outros = Math.max(0, s.itens - s.pecas - s.kits);
    s.resumo = s.itens > 0 ? resumoItens(s.pecas, s.kits, s.outros) + ' · ' + dinheiro(s.total) : '';
    return s;
  }

  function escrever(el, marcacao) {
    if (!el || el._bcTexto === marcacao) return;
    el._bcTexto = marcacao;
    el.innerHTML = marcacao;
  }

  function largura(el, pct) {
    if (el) el.style.width = Math.max(0, Math.min(100, pct)).toFixed(1) + '%';
  }

  /**
   * Pinta o preço do topo e o cartão "Seu pedido" somando a sacola com o que está escolhido na grade.
   * É só exibição: quem aplica o desconto de verdade é a Shopify, no carrinho.
   * Os textos são os mesmos de snippets/bc-progresso-pedido.liquid.
   * Devolve o total estimado e a economia da seleção, para o resumo ao lado do botão.
   */
  function pintarProduto(sel, elegivel, soConta) {
    var s = lerSacola();
    var novas = elegivel ? sel.pecas : 0;
    var total = s.pecas + novas;
    var unit = precoPorPeca(total);
    var estSel = elegivel ? sel.itens.reduce(function (a, i) { return a + i.quantity * Math.min(i.preco, unit); }, 0) : sel.subtotal;
    var ganho = s.pecas * Math.max(0, precoPorPeca(s.pecas) - unit); // a sacola também desce de preço ao mudar de faixa
    var totalEst = s.total - ganho + estSel;
    var economia = s.desconto + ganho + (sel.subtotal - estSel);
    var fa = faixaAtual(total);
    var prox = proximaFaixa(total);
    var B = '<strong>', E = '</strong>';
    var CHECK = '<span class="bc-prog__check" aria-hidden="true">✓</span> ';

    var minimo = CFG.minimoCentavos || 0;
    // UMA frase de situação (rodada 1 item 5), igual à de snippets/bc-progresso-pedido.liquid: abaixo do mínimo, quanto falta;
    // depois, a próxima faixa; na última faixa, o melhor preço. A soma (sacola + grade) está na linha de cima do cartão.
    var frase;
    if (minimo > 0 && totalEst < minimo && (total > 0 || s.itens > 0)) {
      frase = 'Faltam ' + B + dinheiro(minimo - totalEst) + E + ' para o pedido mínimo';
    } else if (prox) {
      frase = 'Mais ' + B + plural(prox.qtd - total, 'peça', 'peças') + E + ' e cada uma sai por ' + B + dinheiro(prox.preco) + E;
    } else {
      frase = 'Você está no melhor preço: ' + B + dinheiro(unit) + E + ' cada';
    }
    // o que falta para a próxima faixa, curto («+7 = R$ 34,90 cada»): só o rodapé da janela de compra rápida usa
    var faltaCurta = '';
    if (elegivel && total > 0) {
      faltaCurta = prox ? '+' + (prox.qtd - total) + ' = ' + dinheiro(prox.preco) + ' cada' : dinheiro(unit) + ' cada peça';
    }
    var resultado = {
      estimado: estSel, economia: sel.subtotal - estSel, frase: frase, falta: faltaCurta, sacola: s.pecas, sacolaItens: s.itens, sacolaTotal: s.total, total: total, unit: unit,
      sacolaResumo: s.resumo, sacolaKits: s.kits, sacolaOutros: s.outros,
      // para as ações do pedido (bloco "Seu pedido" e barra): o mesmo valor que enche a barra do mínimo, sacola + grade com o preço da faixa
      totalEst: totalEst, minimo: minimo, minimoOk: minimo === 0 || totalEst >= minimo, faltaMinimo: Math.max(0, minimo - totalEst)
    };
    // grade da janela de compra rápida: só faz a conta, não mexe no preço nem no cartão da página
    if (soConta) return resultado;

    Array.prototype.forEach.call(document.querySelectorAll('[data-bc-preco]'), function (p) {
      var cheio = p.querySelector('[data-bc-preco-cheio]');
      // sem peças: «A partir de» + o menor preço (o mesmo dos cards); com peças: o preço da faixa atual
      trocarTexto(p.querySelector('[data-bc-preco-atual]'), dinheiro(total > 0 ? unit : (FAIXAS.length ? FAIXAS[FAIXAS.length - 1].preco : CFG.precoBase)));
      Array.prototype.forEach.call(p.querySelectorAll('[data-bc-preco-ate]'), function (ate) { ate.hidden = total > 0; });
      if (cheio) cheio.hidden = !(total > 0 && unit < CFG.precoBase);
      Array.prototype.forEach.call(p.querySelectorAll('[data-bc-faixa]'), function (f) {
        f.classList.toggle('bc-preco__faixa--atual', parseInt(f.getAttribute('data-bc-faixa'), 10) === fa);
      });
    });

    var c = document.querySelector('.bc-prog--produto');
    if (c) {
      c.hidden = total === 0 && s.itens === 0 && sel.pecas === 0;

      // linha de cima: o que há na sacola, com kits contados à parte («12 camisetas + 1 kit · R$ 476,70»), ou a soma com a grade
      var conta = '';
      var semExtras = s.kits === 0 && s.outros === 0;
      if (s.itens > 0 && novas > 0) conta = semExtras
        ? plural(novas, 'nova', 'novas') + ' + ' + s.pecas + ' na sacola = ' + plural(total, PECA, PECAS)
        : plural(novas, 'nova', 'novas') + ' + ' + resumoItens(s.pecas, s.kits, s.outros) + ' na sacola';
      else if (novas > 0) conta = plural(novas, PECA + ' escolhida', PECAS + ' escolhidas');
      else if (s.itens > 0) conta = s.resumo;
      escrever(c.querySelector('[data-bc-conta]'), conta);

      escrever(c.querySelector('[data-bc-frase]'), frase);

      var ultima = FAIXAS.length ? FAIXAS[FAIXAS.length - 1].qtd : 1;
      var alvo = prox ? prox.qtd : ultima;
      // as barras enchem com a mesma conta do texto e dos selos: sacola + grade. Antes só a sacola enchia a barra;
      // a parte da grade aparecia num tom claro, que se lia como barra vazia mesmo com a meta atingida.
      largura(c.querySelector('[data-bc-barra-faixa]'), total * 100 / alvo);
      // legendas curtas, sem repetir a frase: «12 de 20 camisetas» / «✓ 20 camisetas ou mais» (rodada 1 itens 5 e 8)
      escrever(c.querySelector('[data-bc-cap-faixa]'), prox ? B + total + E + ' de ' + prox.qtd + ' ' + PECAS : CHECK + ultima + ' ' + PECAS + ' ou mais');
      var rotFaixa = c.querySelector('[data-bc-rot-faixa]');
      if (rotFaixa) { rotFaixa.hidden = true; escrever(rotFaixa, ''); }

      if (minimo > 0) {
        largura(c.querySelector('[data-bc-barra-min]'), totalEst * 100 / minimo);
        // rodada 2: legenda clara e sem repetir o total. Atingido: «✓ Pedido mínimo atingido»; abaixo: «Pedido mínimo de R$ 299»
        // (o «faltam R$ X» fica só na frase principal, que abaixo do mínimo sempre o diz)
        escrever(c.querySelector('[data-bc-cap-min]'), totalEst >= minimo ? CHECK + 'Pedido mínimo atingido' : 'Pedido mínimo de ' + dinheiro(minimo).replace(/,00$/, ''));
        var rotMin = c.querySelector('[data-bc-rot-min]');
        if (rotMin) { rotMin.hidden = true; escrever(rotMin, ''); }
      }
      c.classList.toggle('bc-prog--min-ok', minimo > 0 && totalEst >= minimo);
      c.classList.toggle('bc-prog--faixa-ok', !prox && total > 0);

      var eco = c.querySelector('[data-bc-eco]');
      if (eco) {
        eco.hidden = !(economia > 0);
        // sem economia o selo fica oculto E vazio: nunca «Você economiza R$ 0,00», nem no texto da página
        escrever(eco, economia > 0 ? 'Você economiza ' + B + dinheiro(economia) + E : '');
      }
    }

    return resultado;
  }

  /* ---------- grade de tamanhos ---------- */

  var CELULAR = window.matchMedia ? window.matchMedia('(max-width: 740px)') : { matches: false };

  /** Abre a gaveta da sacola pelo mesmo caminho do ícone do cabeçalho; sem gaveta, vai para o carrinho. */
  function abrirSacola() {
    // gaveta já aberta (ex.: janela de compra rápida aberta a partir dela): clicar no ícone a fecharia; basta não fazer nada
    var gaveta = document.getElementById('mini-cart');
    if (gaveta && gaveta.hasAttribute('open')) return;
    var icones = document.querySelectorAll('a[aria-controls="mini-cart"]');
    for (var i = 0; i < icones.length; i++) {
      if (icones[i].getClientRects().length) { icones[i].click(); return; }
    }
    window.location.href = URL_CARRINHO;
  }

  class BCGrade extends HTMLElement {
    connectedCallback() {
      if (this._pronto) return;
      this._pronto = true;
      var self = this;
      this.botao = this.querySelector('[data-bc-adicionar]');
      this.rotulo = this.botao ? (this.botao.querySelector('[data-bc-rotulo]') || this.botao) : null;
      this.addEventListener('click', this._aoClicar.bind(this));
      this.addEventListener('input', this._aoDigitar.bind(this));
      this.addEventListener('focusin', function (e) {
        if (e.target.matches('[data-bc-qtd]')) e.target.select();
      });
      this._aoMudarTela = function () { self.atualizar(); };
      if (CELULAR.addEventListener) CELULAR.addEventListener('change', this._aoMudarTela);
      this.atualizar();
    }

    disconnectedCallback() {
      if (CELULAR.removeEventListener && this._aoMudarTela) CELULAR.removeEventListener('change', this._aoMudarTela);
      this._pronto = false;
    }

    _linhas() {
      return Array.prototype.slice.call(this.querySelectorAll('[data-bc-linha]'));
    }

    _limitar(input, valor) {
      var max = parseInt(input.getAttribute('data-max'), 10);
      valor = Math.max(0, Math.floor(valor) || 0);
      if (!isNaN(max) && valor > max) {
        valor = Math.max(0, max);
        var linha = input.closest('[data-bc-linha]');
        this._retorno('Só temos ' + plural(valor, 'peça', 'peças') + ' do tamanho ' + linha.getAttribute('data-nome') + '.', 'erro');
      }
      return valor;
    }

    _aoClicar(e) {
      var menos = e.target.closest('[data-bc-menos]');
      var mais = e.target.closest('[data-bc-mais]');
      if (menos || mais) {
        var input = (menos || mais).closest('[data-bc-linha]').querySelector('[data-bc-qtd]');
        var atual = parseInt(input.value, 10) || 0;
        input.value = this._limitar(input, atual + (mais ? 1 : -1));
        this._fimDoFeito();
        this.atualizar();
        return;
      }
      if (e.target.closest('[data-bc-adicionar]')) {
        var espelhaFinalizar = !!(this.botao && this.botao.hasAttribute('data-bc-fin'));
        if (!this.itens().length) {
          // grade vazia: com a sacola já no mínimo a barra diz "Finalizar pedido" e finaliza; senão (celular) leva até a grade
          if (espelhaFinalizar) finalizar();
          else this.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          this.adicionar({ origem: this.botao, finalizar: espelhaFinalizar });
        }
        return;
      }
      if (e.target.closest('[data-bc-ver-sacola]')) {
        // dentro da janela de compra rápida: fecha a janela antes, senão ela cobre a gaveta
        var caixa = this.closest('dialog');
        if (caixa && caixa.close) caixa.close();
        abrirSacola();
        return;
      }

      var janela = this.querySelector('[data-bc-medidas]');
      if (!janela) return;
      if (e.target.closest('[data-bc-medidas-abrir]')) {
        if (janela.showModal) janela.showModal(); else janela.setAttribute('open', '');
      } else if (e.target.closest('[data-bc-medidas-fechar]') || e.target === janela) {
        // clique no fundo escuro cai no próprio <dialog>
        if (janela.close) janela.close(); else janela.removeAttribute('open');
      }
    }

    _aoDigitar(e) {
      if (!e.target.matches('[data-bc-qtd]')) return;
      var limpo = e.target.value.replace(/\D/g, '');
      e.target.value = limpo === '' ? '' : this._limitar(e.target, parseInt(limpo, 10));
      this._fimDoFeito();
      this.atualizar();
    }

    /** Lista { id, quantity, preco } dos tamanhos com quantidade maior que zero. */
    itens() {
      return this._linhas().map(function (linha) {
        return {
          id: parseInt(linha.getAttribute('data-variante'), 10),
          quantity: parseInt(linha.querySelector('[data-bc-qtd]').value, 10) || 0,
          preco: parseInt(linha.getAttribute('data-preco'), 10) || 0
        };
      }).filter(function (i) { return i.quantity > 0; });
    }

    atualizar() {
      var itens = this.itens();
      var pecas = itens.reduce(function (s, i) { return s + i.quantity; }, 0);
      var subtotal = itens.reduce(function (s, i) { return s + i.quantity * i.preco; }, 0);
      // na janela de compra rápida a grade não usa a barra fixa do celular nem pinta a página
      var rapida = this.hasAttribute('data-bc-rapida');
      var celular = CELULAR.matches && !rapida;

      this._linhas().forEach(function (linha) {
        var q = parseInt(linha.querySelector('[data-bc-qtd]').value, 10) || 0;
        linha.classList.toggle('bc-grade__linha--ativa', q > 0);
      });

      var elegivel = this.getAttribute('data-elegivel') === 'true' && FAIXAS.length > 0;
      // janela rápida aberta numa página de produto: a conta da faixa soma também o que já está escolhido na grade da página
      // (sacola + grade da página + grade da janela), como o cartão «Seu pedido» faz; o total mostrado é só o da janela
      var selConta = { pecas: pecas, subtotal: subtotal, itens: itens };
      if (rapida && elegivel) {
        var gp = gradePrincipal();
        if (gp && gp !== this && gp.getAttribute('data-elegivel') === 'true') {
          var extra = gp.itens();
          selConta = {
            pecas: pecas + extra.reduce(function (s, i) { return s + i.quantity; }, 0),
            subtotal: subtotal + extra.reduce(function (s, i) { return s + i.quantity * i.preco; }, 0),
            itens: itens.concat(extra)
          };
        }
      }
      var conta = pintarProduto(selConta, elegivel, rapida);
      if (rapida && selConta.itens !== itens) {
        conta.estimado = elegivel ? itens.reduce(function (a, i) { return a + i.quantity * Math.min(i.preco, conta.unit); }, 0) : subtotal;
      }
      if (rapida) {
        // linha do preço sob o nome, na janela: a faixa inteira sem peças, o preço da faixa quando houver
        var caixaPreco = this.closest('dialog');
        var linhaPreco = caixaPreco ? caixaPreco.querySelector('[data-bc-rapida-preco]') : null;
        var menor = FAIXAS.length ? FAIXAS[FAIXAS.length - 1].preco : CFG.precoBase;
        if (linhaPreco && elegivel) {
          // sem peças, o mesmo texto dos cards e da página do produto: «A partir de R$ 31,90 por peça» (rodada 1 item 12)
          escrever(linhaPreco, conta.total > 0
            ? '<strong>' + dinheiro(conta.unit) + '</strong> por peça'
            : 'A partir de <strong>' + dinheiro(menor) + '</strong> por peça');
        }
      }

      var vazio = this.querySelector('[data-bc-vazio]');
      var cheio = this.querySelector('[data-bc-cheio]');
      // a confirmação "N peças adicionadas" ocupa o lugar do resumo até o lojista escolher mais peças
      var feito = this.querySelector('[data-bc-feito]');
      if (feito && pecas > 0) { this._fimDoFeito(); feito = null; }
      if (vazio) {
        vazio.hidden = pecas > 0 || !!feito;
        // grade vazia com itens na sacola: o resumo mostra a sacola com kits à parte («12 camisetas + 1 kit · R$ 476,70»),
        // a mesma linha do cartão «Seu pedido» (rodada 1 item 2); na janela rápida não há cartão, fica só o convite
        vazio.textContent = conta.sacolaItens > 0 && !rapida
          ? conta.sacolaResumo
          : (celular ? 'Toque em + para escolher' : 'Escolha as quantidades acima');
      }
      if (cheio) cheio.hidden = pecas === 0;
      // com a grade vazia o trecho «N peças · R$ X» fica vazio (antes guardava «0 peças · R$ 0,00», oculto)
      trocarTexto(this.querySelector('[data-bc-total-pecas]'), pecas > 0 ? plural(pecas, 'peça', 'peças') : '');
      trocarTexto(this.querySelector('[data-bc-total]'), pecas > 0 ? dinheiro(conta.estimado) : '');
      // segunda linha («+7 = R$ 34,90 cada») só na janela de compra rápida, que não tem cartão; na página a barra traz só
      // total e botão: a próxima faixa já está no cartão «Seu pedido» (rodada 1 item 5)
      var falta = this.querySelector('[data-bc-falta]');
      if (falta) falta.textContent = pecas > 0 && rapida ? conta.falta : '';
      this._sombra();

      // A barra (presa à base da coluna; fixa no celular) espelha a ação principal do bloco "Seu pedido": com o mínimo
      // alcançado (sacola + grade) ela adiciona e finaliza; abaixo do mínimo só adiciona, para quem ainda vai montar o
      // pedido com outros modelos. Com a grade vazia e a sacola já no mínimo, vira "Finalizar pedido".
      var fin = !rapida && conta.minimoOk && (pecas > 0 || conta.sacolaItens > 0);
      if (this.botao && !this._enviando) {
        if (pecas > 0 && this.botao.classList.contains('bc-grade__botao--ok')) this._fimDoOk();
        if (!this.botao.classList.contains('bc-grade__botao--ok')) {
          if (fin) this.botao.setAttribute('data-bc-fin', ''); else this.botao.removeAttribute('data-bc-fin');
          this.botao.classList.toggle('bc-grade__botao--fin', fin);
          // sem peças e sem mínimo: desabilitado no desktop; no celular vira o convite que rola até a grade
          this.botao.disabled = pecas === 0 && !fin && !celular;
          this.botao.classList.toggle('bc-grade__botao--convite', pecas === 0 && !fin && celular);
          // desktop, grade vazia e sem mínimo: nenhum botão morto na barra, fica só «Escolha as quantidades acima» (rodada 1 item 4)
          this.botao.classList.toggle('bc-grade__botao--oculto', !rapida && pecas === 0 && !fin && !celular);
          var rotulo;
          if (pecas > 0) rotulo = fin ? (celular ? 'Adicionar e finalizar' : 'Adicionar e finalizar pedido') : (celular ? 'Adicionar' : 'Adicionar à sacola');
          else rotulo = fin ? 'Finalizar pedido' : (celular ? 'Escolher tamanhos' : 'Escolha os tamanhos');
          this._rotulo(rotulo);
        }
      }
      this._pintarAcoes(conta, pecas, rapida);

      // Evento público para outros blocos (calculadora de frete, sugestões): dispara a cada mudança da grade e a cada
      // atualização da sacola. detail.itens = [{ id, quantity, preco }] (o mesmo de itens()); detail.items = [{ variant_id, quantity }].
      document.dispatchEvent(new CustomEvent('bc:grade-alterada', { detail: {
        produto: this.getAttribute('data-produto'), rapida: rapida, pecas: pecas, subtotal: subtotal, total: conta.estimado,
        itens: itens, items: itens.map(function (i) { return { variant_id: i.id, quantity: i.quantity }; })
      } }));
    }

    /** Os dois botões do bloco "Seu pedido" (snippets/bc-pedido-acoes.liquid); só existem para a grade principal da página. */
    _acoes() {
      if (this.hasAttribute('data-bc-rapida')) return [];
      return Array.prototype.slice.call(document.querySelectorAll('[data-bc-pedido] [data-bc-acao-finalizar], [data-bc-pedido] [data-bc-acao-adicionar]'));
    }

    /**
     * Textos e estados dos botões do bloco "Seu pedido", com a mesma conta do cartão (sacola + grade). Nenhum botão morto
     * (rodada 1 item 4): o principal só aparece quando dá para finalizar, «Adicionar e finalizar pedido» (há peças na grade e o
     * mínimo é alcançado) ou «Finalizar pedido» (grade vazia, sacola já no mínimo); «Adicionar à sacola» só aparece com peças
     * na grade e vira o botão verde quando ainda não dá para finalizar. Sem nenhum dos dois, fica a linha
     * «Escolha as quantidades acima para adicionar». O que falta para o mínimo está na frase do cartão.
     */
    _pintarAcoes(conta, pecas, rapida) {
      if (rapida || this._enviando) return;
      var fin = document.querySelector('[data-bc-pedido] [data-bc-acao-finalizar]');
      var add = document.querySelector('[data-bc-pedido] [data-bc-acao-adicionar]');
      var dica = document.querySelector('[data-bc-pedido] [data-bc-acao-dica]');
      var rot = function (b) { return b.querySelector('[data-bc-rotulo]') || b; };
      var podeFinalizar = conta.minimoOk && (pecas > 0 || conta.sacolaItens > 0);
      if (fin && !fin.classList.contains('bc-pedido__btn--ok')) {
        var texto = pecas > 0 ? 'Adicionar e finalizar pedido' : 'Finalizar pedido';
        fin.hidden = !podeFinalizar;
        fin.disabled = !podeFinalizar;
        fin.classList.remove('bc-pedido__btn--falta');
        if (rot(fin).textContent !== texto) rot(fin).textContent = texto;
      }
      if (add && !add.classList.contains('bc-pedido__btn--ok')) {
        add.hidden = pecas === 0;
        add.disabled = pecas === 0;
        add.classList.toggle('bc-pedido__btn--destaque', !podeFinalizar);
        if (rot(add).textContent !== 'Adicionar à sacola') rot(add).textContent = 'Adicionar à sacola';
      }
      if (dica) dica.hidden = pecas > 0 || podeFinalizar;
    }

    _rotulo(texto) {
      if (this.rotulo && this.rotulo.textContent !== texto) this.rotulo.textContent = texto;
    }

    /** Encerra a confirmação animada do botão (na barra e no bloco "Seu pedido"). */
    _fimDoOk() {
      clearTimeout(this._okT);
      this.botao.classList.remove('bc-grade__botao--ok');
      this._acoes().forEach(function (b) { b.classList.remove('bc-pedido__btn--ok'); });
    }

    /** Tira a confirmação "N peças adicionadas" do lugar do resumo. */
    _fimDoFeito() {
      clearTimeout(this._feitoT);
      var el = this.querySelector('[data-bc-feito]');
      if (el && el.parentNode) el.parentNode.removeChild(el);
    }

    /** Sombra suave acima da faixa de ação enquanto ela flutua sobre a lista (a grade continua por baixo). */
    _sombra() {
      var acao = this.querySelector('[data-bc-acao]');
      var lista = this.querySelector('.bc-grade__lista');
      if (!acao || !lista) return;
      acao.classList.toggle('bc-grade__acao--flutua', lista.getBoundingClientRect().bottom > acao.getBoundingClientRect().top + 1);
    }

    /**
     * Confirmação curta no lugar do resumo, ao lado do botão: "N peças adicionadas" e duas ações,
     * "Ver sacola" e, com o pedido mínimo atingido, "Finalizar compra". Some sozinha em 8 s ou ao mexer na grade.
     */
    _feito(pecas, minimoOk, totalSacola) {
      var self = this;
      var resumo = this.querySelector('.bc-grade__resumo');
      if (!resumo) return;
      var el = this.querySelector('[data-bc-feito]');
      if (!el) {
        el = document.createElement('span');
        el.className = 'bc-grade__feito';
        el.setAttribute('data-bc-feito', '');
        resumo.appendChild(el);
      }
      el.textContent = '';
      var forte = document.createElement('strong');
      forte.textContent = '✓ ' + plural(pecas, 'peça adicionada', 'peças adicionadas');
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('data-bc-ver-sacola', '');
      b.textContent = 'Ver sacola';
      var acoes = document.createElement('span');
      acoes.className = 'bc-grade__feito-acoes';
      acoes.appendChild(b);
      // sem «Finalizar pedido» aqui: ele já está no botão da barra e no bloco «Seu pedido» (um só por lugar)
      el.appendChild(forte);
      el.appendChild(document.createTextNode(' '));
      el.appendChild(acoes);
      clearTimeout(this._feitoT);
      this._feitoT = setTimeout(function () { self._fimDoFeito(); self.atualizar(); }, 8000);
    }

    /** Mensagem de erro logo abaixo da grade. "verSacola" acrescenta o atalho que abre a gaveta. */
    _retorno(texto, tipo, verSacola) {
      var el = this.querySelector('[data-bc-retorno]');
      if (!el) return;
      el.textContent = texto;
      el.className = 'bc-grade__retorno' + (tipo ? ' bc-grade__retorno--' + tipo : '');
      if (verSacola) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('data-bc-ver-sacola', '');
        b.textContent = 'Ver sacola';
        el.appendChild(b);
      }
      el.hidden = !texto;
    }

    /**
     * Adiciona as quantidades da grade à sacola num único POST.
     * opcoes.origem: botão que recebeu o clique (barra ou bloco "Seu pedido"); é ele que mostra "Adicionando…".
     * opcoes.finalizar: depois de adicionar, segue para a Yampi por finalizar() ("Adicionar e finalizar pedido").
     * opcoes.depois: URL para onde ir depois de adicionar ("Escolher outros modelos" → coleção).
     */
    adicionar(opcoes) {
      var self = this;
      opcoes = opcoes || {};
      var itens = this.itens();
      if (!itens.length || this._enviando) return;
      var eFinalizar = !!opcoes.finalizar;
      var irDepois = typeof opcoes.depois === 'string' ? opcoes.depois : '';
      var acoes = this._acoes();
      var origem = opcoes.origem && opcoes.origem.classList ? opcoes.origem : this.botao;
      var rotuloOrigem = origem ? (origem.querySelector('[data-bc-rotulo]') || origem) : null;
      var classeCarregando = origem === this.botao ? 'bc-grade__botao--carregando' : 'bc-pedido__btn--carregando';

      var pecas = itens.reduce(function (s, i) { return s + i.quantity; }, 0);
      this._enviando = true;
      this.botao.disabled = true;
      this.botao.setAttribute('aria-busy', 'true');
      this._fimDoOk();
      this.botao.classList.remove('bc-grade__botao--convite');
      acoes.forEach(function (b) { b.disabled = true; });
      origem.classList.add(classeCarregando);
      origem.setAttribute('aria-busy', 'true');
      if (rotuloOrigem) rotuloOrigem.textContent = 'Adicionando…';
      this._retorno('', '');

      var corpo = {
        items: itens.map(function (i) { return { id: i.id, quantity: i.quantity }; }),
        sections: 'mini-cart'
      };

      fetch(RAIZ + '/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(corpo)
      })
        .then(function (r) { return r.json().then(function (json) { return { ok: r.ok, json: json }; }); })
        .then(function (res) {
          if (!res.ok) {
            // 422: a Shopify recusa o pedido inteiro quando um tamanho não tem estoque suficiente.
            throw new Error(res.json.description || res.json.message || 'Não foi possível adicionar.');
          }
          return buscarCarrinho().then(function (carrinho) {
            carrinho.sections = res.json.sections;
            // A gaveta é atualizada mas NÃO abre sozinha: quem adiciona vários modelos não precisa fechá-la a cada vez.
            // Ela abre pelo ícone da sacola ou pelo atalho "Ver sacola" da confirmação.
            document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: carrinho } }));
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: carrinho, openMiniCart: false } }));

            self._linhas().forEach(function (l) { l.querySelector('[data-bc-qtd]').value = 0; });
            self._adicionou = true;
            // em "Adicionar e finalizar pedido" a confirmação não entra: a página segue para o checkout
            if (eFinalizar) self._finalizarDepois = true;
            else if (irDepois) self._irDepois = irDepois;
            else self._feito(pecas, !abaixoDoMinimo(carrinho), carrinho.item_count);
            Array.prototype.forEach.call(document.querySelectorAll('cart-count'), function (c) {
              c.classList.remove('bc-pulso');
              void c.offsetWidth;
              c.classList.add('bc-pulso');
            });
          });
        })
        .catch(function (erro) {
          self._retorno(erro.message || 'Não foi possível adicionar. Tente de novo.', 'erro');
        })
        .then(function () {
          origem.removeAttribute('aria-busy');
          origem.classList.remove(classeCarregando);
          self.botao.removeAttribute('aria-busy');
          self.botao.classList.remove('bc-grade__botao--carregando');
          if (self._finalizarDepois) {
            // "Adicionar e finalizar pedido": as peças já estão na sacola; segue para a Yampi pelo caminho único
            // (finalizar() confere o mínimo com o /cart.js lido agora). Se a guarda barrar, os botões voltam ao normal.
            self._finalizarDepois = false;
            self._adicionou = false;
            origem.classList.add(classeCarregando);
            origem.setAttribute('aria-busy', 'true');
            if (rotuloOrigem) rotuloOrigem.textContent = 'Abrindo o checkout…';
            return finalizar().then(function () {
              origem.removeAttribute('aria-busy');
              origem.classList.remove(classeCarregando);
              self._enviando = false;
              self.atualizar();
            });
          }
          if (self._irDepois) {
            // "Escolher outros modelos" com peças na grade: já estão na sacola; segue para a coleção num toque só
            var destino = self._irDepois;
            self._irDepois = '';
            self._adicionou = false;
            origem.classList.add(classeCarregando);
            origem.setAttribute('aria-busy', 'true');
            if (rotuloOrigem) rotuloOrigem.textContent = 'Abrindo outros modelos…';
            window.location.href = destino;
            return;
          }
          self._enviando = false;
          if (self._adicionou) {
            // confirmação animada por um instante; some sozinha ou assim que o lojista escolher mais peças
            self._adicionou = false;
            self.botao.classList.add('bc-grade__botao--ok');
            self.botao.disabled = true;
            self._rotulo('Adicionado');
            // o mesmo "Adicionado" no botão do bloco "Seu pedido", quando foi ele o clicado
            if (origem !== self.botao) {
              origem.classList.add('bc-pedido__btn--ok');
              origem.disabled = true;
              if (rotuloOrigem) rotuloOrigem.textContent = 'Adicionado';
            }
            self._okT = setTimeout(function () { self._fimDoOk(); self.atualizar(); }, 1800);
          }
          self.atualizar();
        });
    }
  }

  /* ---------- botões do bloco "Seu pedido" (snippets/bc-pedido-acoes.liquid) ---------- */

  function gradePrincipal() {
    return document.querySelector('.product-form bc-grade:not([data-bc-rapida])');
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var fin = e.target.closest('[data-bc-acao-finalizar]');
    var add = e.target.closest('[data-bc-acao-adicionar]');
    var outros = e.target.closest('[data-bc-acao-outros]');
    if (!fin && !add && !outros) return;
    e.preventDefault();
    var grade = gradePrincipal();
    if (outros) {
      // "Escolher outros modelos": com peças na grade, adiciona e vai para a coleção; sem peças, só vai (um toque nos dois casos)
      var destino = outros.getAttribute('href') || RAIZ + '/collections/all';
      if (grade && grade.itens().length && !grade._enviando) grade.adicionar({ origem: outros, depois: destino });
      else if (!grade || !grade._enviando) window.location.href = destino;
      return;
    }
    if ((fin || add).disabled) return;
    if (add) {
      if (grade) grade.adicionar({ origem: add });
      return;
    }
    // "Adicionar e finalizar pedido" com peças na grade; "Finalizar pedido" com a grade vazia e a sacola no mínimo
    if (grade && grade.itens().length) grade.adicionar({ origem: fin, finalizar: true });
    else finalizar();
  });

  if (window.customElements && !window.customElements.get('bc-grade')) {
    window.customElements.define('bc-grade', BCGrade);
  }

  /* ---------- barra da grade x bloco «Seu pedido»: nunca dois botões iguais na mesma tela ---------- */

  // Enquanto os botões do bloco «Seu pedido» estão na tela, a barra da grade (fixa no celular, presa à base da coluna no
  // desktop) some; quando o lojista rola para longe do bloco, ela volta. A margem de baixo desconta a altura da barra fixa:
  // botões escondidos atrás dela contam como fora da tela.
  function vigiarBarra() {
    var acoes = document.querySelector('[data-bc-pedido] [data-bc-acoes]');
    var grade = gradePrincipal();
    if (!acoes || !grade || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entradas) {
      var visivel = entradas[entradas.length - 1].isIntersecting;
      grade.classList.toggle('bc-grade--bloco-visivel', visivel);
      var acao = grade.querySelector('[data-bc-acao]');
      if (acao) acao.setAttribute('aria-hidden', visivel ? 'true' : 'false');
      if (grade._sombra) grade._sombra();
    }, { rootMargin: '0px 0px -72px 0px', threshold: 0 }).observe(acoes);
    // desktop: a linha presa da coluna («12 peças · R$ 418,80») também some enquanto o bloco «Seu pedido» (cartão e ações)
    // está na tela, porque o cartão já diz o mesmo; volta quando o bloco sai da tela. O CSS só aplica isso a partir de 741 px.
    // Observa o invólucro [data-bc-pedido], que não é trocado quando o JS reescreve o conteúdo do cartão.
    var bloco = document.querySelector('[data-bc-pedido]');
    if (bloco) {
      new IntersectionObserver(function (entradas) {
        grade.classList.toggle('bc-grade--pedido-visivel', entradas[entradas.length - 1].isIntersecting);
      }, { threshold: 0 }).observe(bloco);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', vigiarBarra); else vigiarBarra();

  // a sombra da faixa de ação acompanha a rolagem (da página ou da janela de compra rápida)
  var sombraPendente = false;
  function aoRolar() {
    if (sombraPendente) return;
    sombraPendente = true;
    (window.requestAnimationFrame || setTimeout)(function () {
      sombraPendente = false;
      Array.prototype.forEach.call(document.querySelectorAll('bc-grade'), function (g) { if (g._sombra) g._sombra(); });
    });
  }
  document.addEventListener('scroll', aoRolar, { capture: true, passive: true });
  window.addEventListener('resize', aoRolar, { passive: true });

  /* ---------- compra rápida no card: a grade do produto numa janela ---------- */

  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }

  var SVG_MENOS = '<svg viewBox="0 0 14 14" aria-hidden="true" focusable="false"><path d="M2 7h10" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
  var SVG_MAIS = '<svg viewBox="0 0 14 14" aria-hidden="true" focusable="false"><path d="M2 7h10M7 2v10" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
  var SVG_FECHAR = '<svg viewBox="0 0 14 14" aria-hidden="true" focusable="false"><path d="M2 2l10 10M12 2L2 12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';

  /** Mesma marcação de snippets/bc-grade-tamanhos.liquid, montada com os dados de /products/HANDLE.js. */
  function montarGrade(p) {
    var linhas = p.variants.map(function (v) {
      var nome = esc(v.title);
      var d = v.available ? '' : ' disabled';
      return '<div class="bc-grade__linha' + (v.available ? '' : ' bc-grade__linha--esgotado') + '" data-bc-linha data-variante="' + v.id + '" data-preco="' + v.price + '" data-nome="' + nome + '">' +
        '<div class="bc-grade__tam"><span class="bc-grade__nome">' + nome + '</span>' + (v.available ? '' : '<span class="bc-grade__esgotado">Esgotado</span>') + '</div>' +
        '<div class="bc-grade__qtd">' +
        '<button type="button" class="bc-grade__btn" data-bc-menos aria-label="Diminuir ' + nome + '"' + d + '>' + SVG_MENOS + '</button>' +
        '<input type="text" class="bc-grade__input" data-bc-qtd inputmode="numeric" pattern="[0-9]*" autocomplete="off" value="0" aria-label="Quantidade do tamanho ' + nome + '"' + d + '>' +
        '<button type="button" class="bc-grade__btn" data-bc-mais aria-label="Aumentar ' + nome + '"' + d + '>' + SVG_MAIS + '</button>' +
        '</div></div>';
    }).join('');
    var rotulo = esc((p.options[0] && p.options[0].name) || 'Tamanho');
    return '<bc-grade class="bc-grade" data-bc-rapida data-elegivel="true" data-produto="' + p.id + '">' +
      '<div class="bc-grade__cab"><span class="bc-grade__cab-tam">' + rotulo + '</span><span class="bc-grade__cab-qtd">Quantidade</span></div>' +
      '<div class="bc-grade__lista">' + linhas + '</div>' +
      '<div class="bc-grade__acao" data-bc-acao>' +
      '<p class="bc-grade__resumo" aria-live="polite"><span class="bc-grade__vazio" data-bc-vazio>Escolha as quantidades acima</span>' +
      '<span class="bc-grade__cheio" data-bc-cheio hidden><strong data-bc-total-pecas>0 peças</strong> · <strong data-bc-total>' + dinheiro(0) + '</strong><span class="bc-grade__falta" data-bc-falta></span></span></p>' +
      '<button type="button" class="bc-grade__botao button button--primary" data-bc-adicionar disabled><span class="bc-grade__botao-rotulo" data-bc-rotulo>Escolha os tamanhos</span></button>' +
      '</div>' +
      '<p class="bc-grade__retorno" data-bc-retorno role="status" hidden></p>' +
      '</bc-grade>';
  }

  function abrirRapida(handle) {
    var url = RAIZ + '/products/' + handle;
    var d = document.querySelector('dialog.bc-rapida');
    if (!d) {
      d = document.createElement('dialog');
      d.className = 'bc-rapida';
      d.setAttribute('aria-label', 'Escolher tamanhos');
      // clique no fundo escuro cai no próprio <dialog>
      d.addEventListener('click', function (e) {
        if (e.target === d || (e.target.closest && e.target.closest('[data-bc-rapida-fechar]'))) d.close();
      });
      document.body.appendChild(d);
    }
    // sem <dialog> ou sem a grade, o card leva para a página do produto, como sempre levou
    if (!d.showModal || !window.customElements || !window.customElements.get('bc-grade')) { window.location.href = url; return; }
    d.innerHTML = '<div class="bc-rapida__caixa"><p class="bc-rapida__espera">Carregando tamanhos…</p></div>';
    d.showModal();
    d._bcHandle = handle;
    fetch(url + '.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('produto ' + r.status); return r.json(); })
      .then(function (p) {
        if (d._bcHandle !== handle || !d.open) return;
        if (!p.available || !p.options || p.options.length !== 1 || !p.variants || !p.variants.length) { window.location.href = url; return; }
        var foto = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') === -1 ? '?' : '&') + 'width=112' : '';
        d.innerHTML = '<div class="bc-rapida__caixa">' +
          '<div class="bc-rapida__cab">' +
          (foto ? '<img class="bc-rapida__foto" src="' + esc(foto) + '" alt="" width="56" height="56">' : '') +
          '<div class="bc-rapida__info"><strong class="bc-rapida__titulo">' + esc(p.title) + '</strong>' +
          '<span class="bc-rapida__preco" data-bc-rapida-preco></span>' +
          '<a class="bc-rapida__link" href="' + esc(url) + '">Ver página do produto</a></div>' +
          '<button type="button" class="bc-rapida__fechar" data-bc-rapida-fechar aria-label="Fechar">' + SVG_FECHAR + '</button>' +
          '</div>' + montarGrade(p) + '</div>';
      })
      .catch(function () { window.location.href = url; });
  }

  document.addEventListener('click', function (e) {
    var alvo = e.target.closest ? e.target.closest('[data-bc-rapida-abrir]') : null;
    if (alvo) {
      e.preventDefault();
      abrirRapida(alvo.getAttribute('data-bc-rapida-abrir'));
      return;
    }
    // abas da seção "Tabela de medidas" (abaixo das colunas do produto)
    var aba = e.target.closest ? e.target.closest('[data-bc-aba]') : null;
    var secao = aba ? aba.closest('[data-bc-medidas-secao]') : null;
    if (!secao) return;
    var qual = aba.getAttribute('data-bc-aba');
    Array.prototype.forEach.call(secao.querySelectorAll('[data-bc-aba]'), function (b) { b.setAttribute('aria-selected', b === aba ? 'true' : 'false'); });
    Array.prototype.forEach.call(secao.querySelectorAll('[data-bc-painel]'), function (p) { p.hidden = p.getAttribute('data-bc-painel') !== qual; });
  });

  /* ---------- finalizar compra e guarda do checkout nativo ---------- */

  function abaixoDoMinimo(carrinho) {
    return !!(CFG.minimoCentavos && carrinho && carrinho.total_price < CFG.minimoCentavos);
  }

  function avisarMinimo(carrinho) {
    aviso('Faltam ' + dinheiro(CFG.minimoCentavos - carrinho.total_price) +
          ' para o pedido mínimo de ' + dinheiro(CFG.minimoCentavos) + '.',
          window.location.pathname.indexOf('/cart') === -1 ? { href: URL_CARRINHO, texto: 'Ver sacola' } : null);
  }

  var NO_CARRINHO = /\/cart\/?$/.test(window.location.pathname);

  // Funções globais do script da Yampi que levam ao checkout. Guardamos as originais e colocamos uma guarda
  // no lugar: qualquer chamada (onclick="yampiClick()", outro script) confere antes o mínimo com o /cart.js
  // lido NA HORA, e não com o que a página mostra (duas abas, carrinho alterado sem recarregar).
  var NOMES_YAMPI = ['yampiClick', 'getNewCheckoutURL'];
  var originaisYampi = {};

  function embrulharYampi() {
    NOMES_YAMPI.forEach(function (nome) {
      var atual = window[nome];
      if (typeof atual !== 'function' || atual._bcGuarda) return;
      originaisYampi[nome] = atual;
      var guarda = function () { finalizar(); };
      guarda._bcGuarda = true;
      window[nome] = guarda;
    });
  }

  function irParaYampi() {
    if (typeof originaisYampi.yampiClick === 'function') {
      try { originaisYampi.yampiClick(); return; } catch (e) { /* segue para o plano B */ }
    }
    if (NO_CARRINHO) {
      aviso('Não foi possível abrir o checkout. Recarregue a página e tente de novo.');
      return;
    }
    // Fora do /cart e sem a função da Yampi: o /cart é onde o script dela assume o botão.
    window.location.href = URL_CARRINHO;
  }

  /**
   * Caminho único para finalizar: lê o carrinho agora, confere o mínimo e entrega para a Yampi.
   */
  function finalizar() {
    embrulharYampi(); // caso o script da Yampi tenha carregado depois deste
    return buscarCarrinho().then(function (carrinho) {
      if (!carrinho.item_count) {
        aviso('Sua sacola está vazia.');
        atualizarBarras(carrinho);
        return;
      }
      if (abaixoDoMinimo(carrinho)) {
        avisarMinimo(carrinho);
        atualizarBarras(carrinho); // a página podia estar desatualizada
        return;
      }
      irParaYampi();
    }).catch(function () {
      aviso('Não foi possível conferir a sacola. Recarregue a página e tente de novo.');
    });
  }

  // .cart__checkout-button é o botão real do carrinho deste tema (onclick="yampiClick()", sem name="checkout").
  var SELETOR_CHECKOUT = 'a[href*="/checkout"], button[name="checkout"], input[name="checkout"], [data-bc-finalizar], ' +
    '.cart__checkout-button, [onclick*="yampiClick"], [onclick*="getNewCheckoutURL"], [onclick*="/checkout"], .ymp_elem_mainBtn';

  /** Só o checkout da própria loja (mesmo host); o checkout da Yampi fica em outro domínio e não é barrado. */
  function ehUrlDeCheckout(url) {
    try {
      var u = new URL(url, window.location.href);
      return u.host === window.location.host && /(^|\/)checkouts?(\/|$)/.test(u.pathname);
    } catch (e) {
      return false;
    }
  }

  function guardaClique(e) {
    var alvo = e.target.closest && e.target.closest(SELETOR_CHECKOUT);
    if (!alvo) return;
    var ehLinkComum = alvo.tagName === 'A' && !alvo.hasAttribute('data-bc-finalizar') && !alvo.hasAttribute('onclick');
    if (ehLinkComum && !ehUrlDeCheckout(alvo.href)) return;

    // Para na fase de captura: o onclick do próprio botão e o listener da Yampi não chegam a rodar.
    e.preventDefault();
    e.stopImmediatePropagation();
    finalizar();
  }

  /** Formulário do carrinho (página ou gaveta): o tema o usava para ir ao checkout nativo. */
  function ehFormCarrinho(form) {
    if (!form || !form.getAttribute) return false;
    if (form.id === 'mini-cart-form' || (form.classList && form.classList.contains('cart__recap'))) return true;
    try {
      var semBarra = function (p) { return p.replace(/\/+$/, ''); };
      return semBarra(new URL(form.getAttribute('action') || '', window.location.href).pathname) === semBarra(new URL(URL_CARRINHO, window.location.href).pathname);
    } catch (e) {
      return false;
    }
  }

  function guardaSubmit(e) {
    var form = e.target;
    var botao = e.submitter;
    var porBotao = botao && (botao.getAttribute('name') === 'checkout' || (botao.matches && botao.matches(SELETOR_CHECKOUT)));
    var acao = form && form.getAttribute && form.getAttribute('action');
    var porAcao = !!acao && ehUrlDeCheckout(acao);
    // qualquer envio do formulário do carrinho (Enter, script, botão injetado) vira "finalizar": confere o mínimo e vai para a Yampi;
    // só o botão "Atualizar" do tema segue o caminho normal
    var porFormCarrinho = ehFormCarrinho(form) && !(botao && botao.getAttribute('name') === 'update');
    if (!porBotao && !porAcao && !porFormCarrinho) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    finalizar();
  }

  if (CFG.guardaCheckout !== false) {
    document.addEventListener('click', guardaClique, true);
    document.addEventListener('submit', guardaSubmit, true);
    document.documentElement.classList.add('bc-sem-checkout-nativo');
    embrulharYampi();
    // o script da Yampi é inline no fim do <body>; repete depois do carregamento por garantia
    document.addEventListener('DOMContentLoaded', embrulharYampi);
    window.addEventListener('load', embrulharYampi);
  } else {
    // Mesmo sem a guarda, os botões [data-bc-finalizar] precisam funcionar.
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-bc-finalizar]')) {
        e.preventDefault();
        finalizar();
      }
    });
  }

  buscarCarrinho().catch(function () {});

  window.BCAtacado = {
    dinheiro: dinheiro,
    precoPorPeca: precoPorPeca,
    proximaFaixa: proximaFaixa,
    atualizarBarras: atualizarBarras,
    finalizar: finalizar,
    // API pública da compra rápida (cards de sugestão etc.): abre a janela com a grade do produto pelo handle.
    // Mesmo caminho do atributo data-bc-rapida-abrir="HANDLE", que continua funcionando por delegação no document.
    abrirRapida: abrirRapida,
    gradePrincipal: gradePrincipal
  };
})();